const MMK_FORMATTER = new Intl.NumberFormat('en-US');

export function formatMMK(value) {
  return `${MMK_FORMATTER.format(value)} Ks`;
}
